@for (row of rows().controls; track $index) {
    <app-fuel-row [group]="row" [refuelRequired]="true" [fields]="fields" [units]="units()" [maxTank]="maxTank()"></app-fuel-row>
}
